export default __webpack_public_path__ + "static/media/linkedlogo.f1d66832.png";